import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { clearApplyCoupon, clearApplyCouponRental, getCouponList, postCoupon, postCouponRental } from "redux/actions/UserCouponAction";
import useModal from "components/hook/useModal";
import CommonCardDialog from "components/commonCardDialog/CommonCardDialog";
import coupon from "assets/images/copon.svg";
import couponApplied from "assets/images/couponApplied.svg";
import rightIcon from "assets/images/caretRight.svg";

function CouponDesign(props) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [couponName, setCouponName] = useState("");
//   const [open, setOpen] = useState(false);
  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const couponListData = useSelector(
    (state) => state?.userCouponList?.userCouponList?.data
  );
  const couponApplyDate = useSelector(
    (state) => state?.userCouponApply?.userCouponApply?.data);
  
  const couponRentalApplyDate = useSelector(
      (state) => state?.userRentalCouponApply?.userCouponRental?.data);
  
  const sessionPickup = sessionStorage.getItem("pickup");
  const sessionDrop = sessionStorage.getItem("drop");
  const dateOne = sessionStorage.getItem("date");
  const endDateOne = sessionStorage.getItem("endDate");

  const { open, toggle } = useModal();

  let couponData = {
    type: params?.type,
    distance: params?.distance || "undefined",
    rateId: params?.carId,
    sourceAddress:
      JSON.parse(sessionPickup)?.description ||
      JSON.parse(sessionPickup)?.formatted_address,
    destinationAddress:
      JSON.parse(sessionDrop)?.description ||
      JSON.parse(sessionDrop)?.formatted_address ||
      (JSON.parse(sessionDrop)?.vicinity &&
        JSON.parse(sessionDrop)?.name +
          ", " +
          JSON.parse(sessionDrop)?.vicinity) ||
      JSON.parse(sessionDrop)?.name,
    eta: params?.eta || "undefined",
    startTime: dateOne,
    expectedReturnTime: endDateOne,
  };

  useEffect(() => {
    let couponSlabId = {};

    if (params?.type === "3") {
      couponSlabId = {
        ...couponData,
        slabId: params?.slabId,
        eta: 0,
        distance: 0,
      };
    } else {
      couponSlabId = {
        ...couponData,
      };
    }
    dispatch(getCouponList(couponSlabId));
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearApplyCoupon());
      dispatch(clearApplyCouponRental());
      setCouponName('');
    }
  }, [])

  useEffect(() => {
    setCouponName(couponApplyDate?.data?.[0] || couponRentalApplyDate?.data?.[0])
  }, [couponApplyDate?.data?.[0]?.couponCode || couponRentalApplyDate?.data?.[0]?.couponCode])
  
  //Apply Coupon
  const applyCoupon = (data) => {
    const applyCouponData = {
      payloadData: {
      type: params?.type,
      distance: params?.distance || "undefined",
      rateId: params?.carId,
      sourceAddress:
        JSON.parse(sessionPickup)?.description ||
        JSON.parse(sessionPickup)?.formatted_address,
      destinationAddress:
        JSON.parse(sessionDrop)?.description ||
        JSON.parse(sessionDrop)?.formatted_address ||
        (JSON.parse(sessionDrop)?.vicinity &&
          JSON.parse(sessionDrop)?.name +
            ", " +
            JSON.parse(sessionDrop)?.vicinity) ||
        JSON.parse(sessionDrop)?.name,
      eta: params?.eta || "undefined",
      startTime: dateOne,
      expectedReturnTime: endDateOne,
      couponId: data?.id,
      couponCode: data?.couponCode,
    },
    actionName:'add'
  }
    let applyCouponSlabId = {};

    if (params?.type === "3") {
      applyCouponData.payloadData = {
        ...applyCouponData.payloadData,
        slabId: params?.slabId,
        eta: "undefined",
        distance: "undefined",
      };
      dispatch(postCouponRental(applyCouponData,toggle));
    } else {
        applyCouponSlabId = {
        ...applyCouponData,
      };
      dispatch(postCoupon(applyCouponData,toggle));
    }
  };

  //Remove Coupon
  const removeCoupon = () => {
    const applyCouponData = {
      payloadData: {
        type: params?.type,
        distance: params?.distance,
        rateId: params?.carId,
        sourceAddress:
          JSON.parse(sessionPickup)?.description ||
          JSON.parse(sessionPickup)?.formatted_address,
        destinationAddress:
          JSON.parse(sessionDrop)?.description ||
          JSON.parse(sessionDrop)?.formatted_address ||
          (JSON.parse(sessionDrop)?.vicinity &&
            JSON.parse(sessionDrop)?.name +
              ", " +
              JSON.parse(sessionDrop)?.vicinity) ||
          JSON.parse(sessionDrop)?.name,
        eta: params?.eta,
        startTime: dateOne,
        expectedReturnTime: endDateOne,
      },
      
      actionName:'remove'
    };
    if (params?.type === "3") {
      applyCouponData.payloadData = {
        ...applyCouponData.payloadData,
        slabId: params?.slabId,
        eta: "undefined",
        distance: "undefined",
      };
      dispatch(postCouponRental(applyCouponData));
    } else {
      dispatch(postCoupon(applyCouponData));
    }
  };

  const handleOpen = () => {
    toggle();
  };

  const handleClose = () => {
    toggle();
  };

  return (
    <div>
      <Grid
        container
        className="justifyBetween colorGrey marginTop25 marginBlock10 tripBtn p10 boxShadowGrey"
      >

        {couponName?.couponCode ? 
        <>
        <Grid item>
          <Typography className="font16 justifyCenter colorBlack"> <img src={couponApplied} alt='couponImg' className="marginRight6"/>You saved ₹ {couponName?.discountAmount} with &nbsp; <span className="fw700">{ couponName?.couponCode} </span></Typography>
        </Grid>
        <Grid item><Button className="font14 colorLightRed" onClick={() => removeCoupon()}>Remove</Button> 
        </Grid>
        </> : 
         <>
         <Grid item>
           <Typography className="font14"> Type coupon code here</Typography>
         </Grid>
         <Grid item>
           <Typography className="font14">Apply</Typography>
         </Grid>
         </> }
      </Grid>

      <Grid container className="justifyBetween marginBlock10">
        <Grid item className="dflex">
          <img src={coupon} alt="coupon" className="wh24" />
          <Typography className="marginLeft10 font16">
            View all Coupon
          </Typography>
        </Grid>
        <Grid item>
          <img
            src={rightIcon}
            alt="coupon"
            className="wh24 cursor"
            onClick={handleOpen}
          />
        </Grid>
      </Grid>

      {open && (
        <CommonCardDialog
          handleClose={handleClose}
          open={open}
          titleCoupon={"Coupons for you"}
          closeFalse={true}
          couponListData={couponListData}
          applyCoupon={applyCoupon}
        />
      )}
    </div>
  );
}

export default CouponDesign;
